import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

$(document).ready(function () {

    gsap.registerPlugin(ScrollTrigger);

	if ($('.sbsbank__elemental__inlinelinkselement').length > 0) {

		// pin the element when the body is scrolling, end when the top of the footer is center of the screen
		gsap.to('.sbsbank__elemental__inlinelinkselement', {
			scrollTrigger: {
				trigger: '.sbsbank__elemental__inlinelinkselement',
				start: 'top top',
				endTrigger: '.c-footer',
				end: 'top top',
				pin: ".e-inline-links",
				toggleClass: { targets: ".e-inline-links", className: "e-inline-links--sticky" },
				pinSpacing: false,
				// markers: true,
			}
		});
	}
});